import RandomNumberGenerator from "./components/RandomNumberGenerator";

function App() {
  return (
    <div className="App">
      <RandomNumberGenerator />
    </div>
  );
}

export default App;
